/*
 * File: /src/services/searchServices.js
 * Created Date: Sunday October 10th 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 10th October 2021 5:17:09 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */
import { authedAxios } from '../shared/axiosWrapper';
import { S2_VER_URL } from '../constants';

export default {
  searchByContactNameEmail(query, offset, length = true) {
    if (!query) {
      throw 'No query set for search';
    }
    const params = {
      query: query,
      offset: offset || 0,
      length: length,
    };
    return authedAxios.get(S2_VER_URL + 'search', {
      params: params,
    });
  },
};
